import { render, staticRenderFns } from "./SkribblePopup.vue?vue&type=template&id=1ffa0bb2&scoped=true&"
import script from "./SkribblePopup.vue?vue&type=script&lang=js&"
export * from "./SkribblePopup.vue?vue&type=script&lang=js&"
import style0 from "./SkribblePopup.vue?vue&type=style&index=0&id=1ffa0bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa0bb2",
  null
  
)

export default component.exports